<template>
    <hts-modal
        v-model="visible"
        :title="$t('labels.cancelTrip')"
        @close="resetFields">
        <template #custom>
            <p class="font-bold">
                Khi bạn thực hiện thao tác hủy chuyến hàng, chuyến hàng và các chặng hàng khác của chuyến cũng sẽ bị hủy và không thể khôi phục.
            </p>

            <hts-form-radio
                v-model="reason"
                label="Vui lòng chọn lí do hủy"
                :items="reasonOptions"
                value-key="key"
                label-key="label"
                required />

            <hts-form-input
                v-if="reason === 'other'"
                v-model="reasonOrther"
                required
                label="Lý do khác" />

            <div class="flex mt-5 justify-end">
                <hts-form-button
                    color="primary"
                    type="submit"
                    :loading="false"
                    :disabled="CDisabled"
                    @click="submit">
                    {{ $t('labels.cancelTrip') }}
                </hts-form-button>

                <hts-form-button
                    class="pl-2"
                    color="error"
                    @click="close">
                    {{ $t('labels.cancel') }}
                </hts-form-button>
            </div>
        </template>
    </hts-modal>
</template>

<script setup lang="ts">
import reasonOption from './reason'
import { $api, $urlPartner } from '#imports'
const emits = defineEmits(['refreshTables'])

const visible = ref(false)

const tripId = ref('')

const moderationStatusCancel = -1

const { reason, reasonOrther, reasonOptions, CReasonLabel, CDisabled } = reasonOption()

const open = (id: string) => {
  tripId.value = id
  visible.value = true
}

const close = () => {
  resetFields()
  visible.value = false
}

const resetFields = () => {
  tripId.value = ''
  reason.value = ''
}

const submit = async () => {
  const api = $urlPartner.trip.trip.updateModerationStatus
  const data: any = await $api(api, {
    uriParams: { ID: tripId.value },
    body: {
      reasonCancel: reason.value,
      reasonCancelLabel: CReasonLabel.value,
      moderationStatus: moderationStatusCancel
    }
  })
  const resData = data?.data?.value
  if (resData?.success) {
    emits('refreshTables')
    process.client && $toast().success($t('labels.updateStatusSuccess'))
    close()
  }
}

defineExpose({ open })
</script>
